module.exports = __webpack_public_path__ + "static/media/perk-3-new.1d1da84e.jpg";